import { Section, type SectionProps } from "components/section";
import React from "react";
import { AuraPlate, type AuraPlateProps } from "ui/plates";
import { TextTitle, type TextTitleProps } from "ui/text";
import { desktopOnlyDisplay, mobileOnlyDisplay } from "utils";
import { AidDemoVideo } from "./aid-demo-video";

type AidDemoVideoSectionProps = {
  hasAuraPlate?: boolean;
  auraVariant?: AuraPlateProps["variant"];
} & SectionProps &
  Pick<TextTitleProps, "title" | "description"> & {
    textMaxW?: TextTitleProps["maxW"];
  };

export function AidDemoVideoSection({
  hasAuraPlate = false,
  auraVariant = "violet",
  title,
  description,
  textMaxW,
  ...props
}: AidDemoVideoSectionProps) {
  return (
    <Section {...props}>
      <TextTitle size="lg" align="center" title={title} description={description} maxW={textMaxW} />
      {hasAuraPlate ? (
        <>
          <AidDemoVideo display={mobileOnlyDisplay()} borderColor="transparent" borderRadius="small" />
          <AuraPlate
            condensed
            display={desktopOnlyDisplay()}
            variant={auraVariant}
            px="0"
            platePx={{ base: "0", md: "bigger" }}
            platePy={{ base: "0", md: "bigger" }}
          >
            <AidDemoVideo borderColor="transparent" borderRadius="bigger" mt="0" />
          </AuraPlate>
        </>
      ) : (
        <AidDemoVideo />
      )}
    </Section>
  );
}
